import {
  Component,
  OnInit,
  NgModule,
  SimpleChanges,
  OnChanges,
  ChangeDetectorRef,
  AfterViewChecked,
  ContentChild,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  AfterViewInit,
  HostBinding,
  DoCheck,
  forwardRef
} from '@angular/core';
import {
  FormsModule,
  ControlValueAccessor,
  Validator,
  UntypedFormControl,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS
} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {MyException} from './multiselect.model';
import {DropdownSettings} from './multiselect.interface';
import {ClickOutsideDirective, ScrollDirective, SetPositionDirective, StylePropDirective} from './clickOutside';
import {ListFilterPipe} from './list-filter';
import {
  ItemComponent,
  BadgeComponent,
  SearchComponent,
  TemplateRendererComponent,
  IconComponent
} from './menu-item';

export const DROPDOWN_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line:no-use-before-declare
  useExisting: forwardRef(() => MultiSelectComponent),
  multi: true
};

export const DROPDOWN_CONTROL_VALIDATION: any = {
  provide: NG_VALIDATORS,
  // tslint:disable-next-line:no-use-before-declare
  useExisting: forwardRef(() => MultiSelectComponent),
  multi: true,
};

const noop = () => {
};

@Component({
  selector: 'ngn-multiselect',
  templateUrl: './multiselect.component.html',
  // tslint:disable-next-line:use-host-property-decorator
  host: {'[class]': 'defaultSettings.classes'},
  styleUrls: ['./multiselect.component.scss'],
  providers: [DROPDOWN_CONTROL_VALUE_ACCESSOR, DROPDOWN_CONTROL_VALIDATION]
})

export class MultiSelectComponent implements OnInit, DoCheck, AfterViewInit,
  ControlValueAccessor, OnChanges, Validator, AfterViewChecked {
  @Input('data')
  data: Array<any>;

  @Input()
  settings: DropdownSettings;

  // tslint:disable-next-line:no-output-on-prefix
  @Output()
  onSelect: EventEmitter<any> = new EventEmitter<any>();

  // tslint:disable-next-line:no-output-on-prefix
  @Output()
  onDeSelect: EventEmitter<any> = new EventEmitter<any>();

  // tslint:disable-next-line:no-output-on-prefix
  @Output()
  onSelectAll: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();

  // tslint:disable-next-line:no-output-on-prefix
  @Output()
  onDeSelectAll: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();

  // tslint:disable-next-line:no-output-on-prefix
  @Output()
  onOpen: EventEmitter<any> = new EventEmitter<any>();

  // tslint:disable-next-line:no-output-on-prefix
  @Output()
  onClose: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  applyClick: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  clearClick: EventEmitter<any> = new EventEmitter<any>();

  @ContentChild(ItemComponent) itemTempl: ItemComponent;
  @ContentChild(BadgeComponent) badgeTempl: BadgeComponent;
  @ContentChild(SearchComponent) searchTempl: SearchComponent;
  @ContentChild(IconComponent) iconTempl: IconComponent;

  @ViewChild('searchInput') searchInput: ElementRef;
  @ViewChild('selectedList', { static: true }) selectedListElem: ElementRef;

  public selectedItems: Array<any>;
  public appliedItems: Array<any> = [];
  public isActive = false;
  public isSelectAll = false;
  public groupedData: Array<any>;
  filter: any;
  public chunkArray: any[];
  public scrollTop: any;
  public chunkIndex: any[] = [];
  public cachedItems: any[] = [];
  public totalRows: any;
  public itemHeight: any = 41.6;
  public screenItemsLen: any;
  public cachedItemsLen: any;
  public totalHeight: any;
  public scroller: any;
  public maxBuffer: any;
  public lastScrolled: any;
  public lastRepaintY: any;
  public selectedListHeight: any;

  defaultSettings: DropdownSettings = {
    singleSelection: false,
    text: 'Select',
    textSelected: 'Selected',
    enableCheckAll: true,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: false,
    searchBy: [],
    maxHeight: 300,
    showBadge: true,
    badgeShowLimit: 999999999999,
    classes: '',
    disabled: false,
    searchPlaceholderText: 'Search',
    showCheckbox: true,
    noDataLabel: 'No Data Available',
    searchAutofocus: true,
    lazyLoading: false,
    labelKey: 'itemName',
    primaryKey: 'id',
    position: 'bottom',
    showApply: false,
    showClear: false,
    iconMode: false,
  };

  public parseError: boolean;

  private onTouchedCallback: (_: any) => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  constructor(public _elementRef: ElementRef, private cdr: ChangeDetectorRef) {

  }

  ngOnInit() {
    this.settings = Object.assign(this.defaultSettings, this.settings);
    if (this.settings.groupBy) {
      this.groupedData = this.transformData(this.data, this.settings.groupBy);
    }
    this.totalRows = (this.data && this.data.length);
    this.cachedItems = this.data;
    this.screenItemsLen = Math.ceil(this.settings.maxHeight / this.itemHeight);
    this.cachedItemsLen = this.screenItemsLen * 3;
    this.totalHeight = this.itemHeight * this.totalRows;
    this.maxBuffer = this.screenItemsLen * this.itemHeight;
    this.lastScrolled = 0;
    this.renderChunk(0, this.cachedItemsLen / 2);
    if (this.settings.position === 'top') {
      setTimeout(() => {
        this.selectedListHeight = {val: 0};
        this.selectedListHeight.val = this.selectedListElem.nativeElement.clientHeight;
      });
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data && !changes.data.firstChange) {
      if (this.settings.groupBy) {
        this.groupedData = this.transformData(this.data, this.settings.groupBy);
        if (this.data.length === 0) {
          this.selectedItems = [];
          this.appliedItems = [];
        }
      }
    }
    if (changes.settings && !changes.settings.firstChange) {
      this.settings = Object.assign(this.defaultSettings, this.settings);
    }
  }

  ngDoCheck() {
    if (this.selectedItems) {
      if (this.selectedItems.length === 0 || this.data.length === 0 || this.selectedItems.length < this.data.length) {
        this.isSelectAll = false;
      }
    }
  }

  ngAfterViewInit() {
    if (this.settings.lazyLoading) {
      this._elementRef.nativeElement.getElementsByClassName('lazyContainer')[0].addEventListener('scroll', this.onScroll.bind(this));
    }
  }

  ngAfterViewChecked() {
    if (this.selectedListElem.nativeElement.clientHeight && this.settings.position === 'top' && this.selectedListHeight) {
      this.selectedListHeight.val = this.selectedListElem.nativeElement.clientHeight;
      this.cdr.detectChanges();
    }
  }

  onItemClick(item: any, index: number, evt: Event) {
    if (this.settings.disabled) {
      return false;
    }

    const found = this.isSelected(item);
    const limit = this.selectedItems.length < this.settings.limitSelection ? true : false;

    if (!found) {
      if (this.settings.limitSelection) {
        if (limit) {
          this.addSelected(item);
          this.onSelect.emit(item);
        }
      } else {
        this.addSelected(item);
        this.onSelect.emit(item);
      }

    } else {
      this.removeSelected(item);
      this.onDeSelect.emit(item);
    }
    if (this.isSelectAll || this.data.length > this.selectedItems.length) {
      this.isSelectAll = false;
    }
    if (this.data.length === this.selectedItems.length) {
      this.isSelectAll = true;
    }
  }

  public validate(c: UntypedFormControl): any {
    return null;
  }

  writeValue(value: any) {
    if (value !== undefined && value !== null) {
      if (this.settings.singleSelection) {
        try {

          if (value.length > 1) {
            this.selectedItems = [value[0]];
            throw new MyException(404, {'msg': 'Single Selection Mode, Selected Items cannot have more than one item.'});
          } else {
            this.selectedItems = value;
          }
        } catch (e) {
          console.error(e.body.msg);
        }

      } else {
        if (this.settings.limitSelection) {
          this.selectedItems = value.splice(0, this.settings.limitSelection);
        } else {
          this.selectedItems = value;
        }
        if (this.selectedItems.length === this.data.length && this.data.length > 0) {
          this.isSelectAll = true;
        }
        this.appliedItems = [...this.selectedItems];
      }
    } else {
      this.selectedItems = [];
      this.appliedItems = [];
    }
  }

  // From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  // From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  trackByFn(index: number, item: any) {
    return item[this.settings.primaryKey];
  }

  isSelected(clickedItem: any) {
    let found = false;
    if (this.selectedItems) {
      this.selectedItems.forEach(item => {
        if (clickedItem[this.settings.primaryKey] === item[this.settings.primaryKey]) {
          found = true;
        }
      });
    }
    return found;
  }

  addSelected(item: any) {
    if (this.settings.singleSelection) {
      this.selectedItems = [];
      this.selectedItems.push(item);
      this.closeDropdown();
    } else {
      this.selectedItems.push(item);
    }

    if (!(this.settings.showApply && !this.settings.singleSelection)) {
      this.onChangeCallback(this.selectedItems);
      this.onTouchedCallback(this.selectedItems);
    }
  }

  removeSelected(clickedItem: any) {
    if (this.selectedItems) {
      this.selectedItems.forEach(item => {
        if (clickedItem[this.settings.primaryKey] === item[this.settings.primaryKey]) {
          this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
        }
      });
    }
    if (!(this.settings.showApply && !this.settings.singleSelection)) {
      this.onChangeCallback(this.selectedItems);
      this.onTouchedCallback(this.selectedItems);
    }
  }

  toggleDropdown(evt: any) {
    if (this.settings.disabled) {
      return false;
    }
    this.isActive = !this.isActive;
    if (this.isActive) {
      if (this.settings.searchAutofocus && this.settings.enableSearchFilter && !this.searchTempl) {
        setTimeout(() => {
          this.searchInput.nativeElement.focus();
        }, 0);
      }
      this.onOpen.emit(true);
    } else {
      this.onClose.emit(false);
    }
    evt.preventDefault();
  }

  closeDropdown() {
    if (this.searchInput && this.settings.lazyLoading) {
      this.searchInput.nativeElement.value = '';
      this.data = [];
      this.data = this.cachedItems;
      this.totalHeight = this.itemHeight * this.data.length;
      this.totalRows = this.data.length;
      this.updateView(this.scrollTop);
    }
    if (this.searchInput) {
      this.searchInput.nativeElement.value = '';
    }

    if (this.settings.showApply && !this.settings.singleSelection) {
      this.selectedItems = [...this.appliedItems];
    }

    this.filter = '';
    this.isActive = false;
    this.onClose.emit(false);
  }

  toggleSelectAll() {
    if (!this.isSelectAll) {
      this.selectedItems = [];
      this.selectedItems = this.data.slice();
      this.isSelectAll = true;
      if (!(this.settings.showApply && !this.settings.singleSelection)) {
        this.onChangeCallback(this.selectedItems);
        this.onTouchedCallback(this.selectedItems);
      }

      this.onSelectAll.emit(this.selectedItems);
    } else {
      this.selectedItems = [];
      this.isSelectAll = false;
      if (!(this.settings.showApply && !this.settings.singleSelection)) {
        this.onChangeCallback(this.selectedItems);
        this.onTouchedCallback(this.selectedItems);
      }

      this.onDeSelectAll.emit(this.selectedItems);
    }
  }

  onClearClick() {
    this.isActive = false;
    this.selectedItems = [];
    this.appliedItems = [];
    this.onChangeCallback(this.selectedItems);
    this.onTouchedCallback(this.selectedItems);
    this.clearClick.emit(this.appliedItems);
  }

  onApplyClick() {
    this.isActive = false;
    this.appliedItems = [...this.selectedItems];
    this.onChangeCallback(this.selectedItems);
    this.onTouchedCallback(this.selectedItems);
    this.applyClick.emit(this.appliedItems);
  }

  transformData(arr: Array<any>, field: any): Array<any> {
    const groupedObj: any = arr.reduce((prev: any, cur: any) => {
      if (!prev[cur[field]]) {
        prev[cur[field]] = [cur];
      } else {
        prev[cur[field]].push(cur);
      }
      return prev;
    }, {});
    const tempArr: any = [];
    Object.keys(groupedObj).map(function (x) {
      tempArr.push({key: x, value: groupedObj[x]});
    });
    return tempArr;
  }

  renderChunk(fromPos: any, howMany: any) {
    this.chunkArray = [];
    this.chunkIndex = [];
    let finalItem = fromPos + howMany;
    if (finalItem > this.totalRows) {
      finalItem = this.totalRows;
    }

    for (let i = fromPos; i < finalItem; i++) {
      this.chunkIndex.push((i * this.itemHeight) + 'px');
      this.chunkArray.push(this.data[i]);
    }
  }

  public onScroll(e: any) {
    this.scrollTop = e.target.scrollTop;
    this.updateView(this.scrollTop);

  }

  public updateView(scrollTop: any) {
    const scrollPos = scrollTop ? scrollTop : 0;
    let first = (scrollPos / this.itemHeight) - this.screenItemsLen;
    const firstTemp = '' + first;
    first = parseInt(firstTemp, 10) < 0 ? 0 : parseInt(firstTemp, 10);
    this.renderChunk(first, this.cachedItemsLen);
    this.lastRepaintY = scrollPos;
  }

  public filterInfiniteList(evt: any) {
    const filteredElems: Array<any> = [];
    this.data = this.cachedItems.slice();
    if (evt.target.value.toString() !== '') {
      this.data.filter(function (el: any) {
        for (const prop in el) {
          if (el[prop].toString().toLowerCase().indexOf(evt.target.value.toString().toLowerCase()) >= 0) {
            filteredElems.push(el);
            break;
          }
        }
      });
      // this.cachedItems = this.data;
      this.totalHeight = this.itemHeight * filteredElems.length;
      this.totalRows = filteredElems.length;
      this.data = [];
      this.data = filteredElems;
      this.updateView(this.scrollTop);
    } else if (evt.target.value.toString() === '' && this.cachedItems.length > 0) {
      this.data = [];
      this.data = this.cachedItems;
      this.totalHeight = this.itemHeight * this.data.length;
      this.totalRows = this.data.length;
      this.updateView(this.scrollTop);
    }
  }
}

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [
    MultiSelectComponent,
    ClickOutsideDirective,
    ScrollDirective,
    StylePropDirective,
    ListFilterPipe,
    ItemComponent,
    TemplateRendererComponent,
    BadgeComponent,
    SearchComponent,
    IconComponent,
    SetPositionDirective,
  ],
  exports: [
    MultiSelectComponent,
    ClickOutsideDirective,
    ScrollDirective,
    StylePropDirective,
    ListFilterPipe,
    ItemComponent,
    TemplateRendererComponent,
    BadgeComponent,
    SearchComponent,
    IconComponent,
    SetPositionDirective,
  ]
})
export class MultiSelectModule {
}
